import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const PlanovanaPujcka = {
	name: NAME,
	apiProvider,
	router,
};
